import axios from "axios";
const api = axios.create({
    baseURL : 'https://makeeasyway.in/resumeData',
    // baseURL : 'http://localhost/resumeData',
    timeout: 10000,
    header: {
        'Content-Type' : 'application/json'
    }
});
api.interceptors.request.use(   
    (config)=>{
        const token = localStorage.getItem('token'); 
        if(token){    
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config; 
    },
    (error)=>{ 
        return Promise.reject(error);
    }
);
api.interceptors.response.use(
    (response)=>{
        return response;
    },
    (error)=>{
     if(error.response){
        console.error("Api error" , error.response.data)
     }else if(error.request){
        console.error('network error', error.message)
     }else{
        console.error("request setup error ", error.request.message)
     }   
     return Promise.reject(error);
    }
);
export default api;